import React from 'react'
import PropTypes from 'prop-types'
import { links, string, compose } from 'common/helpers'
import { connect } from 'redaction'
import { injectIntl } from 'sb-react-intl'

import ImageWithPlaceholderFallback from 'components/ui/ImageWithPlaceholderFallback/ImageWithPlaceholderFallback'
import Message from 'components/text/Message/Message'
import Link from 'components/ui/Link/Link'

import messages from './messages.js'
import s from './NoteResult.scss'


const NoteResult = ({ index, note: { name, img }, note, onClick, gender, intl }) => {
  const safeName = string.trimHtml(name)
  const url = gender === 'male' ? links.subscription.colognes : links.subscription.perfumes

  return (
    <Link
      className={s.link}
      to={url}
      onClick={() => onClick({ note: { ...note, name: safeName }, position: index + 1 })}
      blackToBrandColor
      aria-label={intl.formatMessage(messages.goTo, { note: `${safeName}` })}
    >
      <ImageWithPlaceholderFallback
        className={s.image}
        src={img}
        w={100}
        role="presentation"
      />
      <Message tag="div" className={s.name} text={name} html />
    </Link>
  )
}

NoteResult.propTypes = {
  index: PropTypes.number,
  note: PropTypes.shape({
    name: PropTypes.string.isRequired,
    img: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,

  intl: PropTypes.object, // @injectIntl
  gender: PropTypes.oneOf([ 'female', 'male' ]), // @connect
}


export default compose(
  injectIntl,
  connect({
    gender: 'models.me.gender',
  })
)(NoteResult)
